import clsx from 'clsx'
import React from 'react'
import { TABS } from './Fields'

export default function FilterBar({ numberIncompleteField, activeTab, onTabClick }) {
  return (
    <div className="filter-bar">
      <div className="dome-d-flex dome-align-center dome-justify-between">
        <span className="dome-p2 dome-color-med-grey">filter</span>
        <div className="dome-d-flex dome-align-center">
          {Object.values(TABS).map((tab) => (
            <div key={tab} onClick={() => onTabClick(tab)} className="dome-relative">
              <div className="filter-bar-tab-item dome-d-flex dome-align-center">
                <span
                  className={clsx('dome-p3', tab === activeTab ? 'dome-color-darkest-grey' : 'dome-color-med-grey')}
                >
                  {tab} {tab === TABS.INCOMPLETE && `(${numberIncompleteField})`}
                </span>
              </div>
              {tab === activeTab && (
                <div
                  className="dome-absolute dome-full-width"
                  style={{ height: 2, bottom: 0, background: 'var(--darkest-grey, #4A4A4A)' }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
